export const projectNameValidator = /(^[^\n\r]*?[^\s][^\n\r]*$|^$)/;